import PropTypes from 'prop-types';

export const StatusShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
});

export const AssetShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  clientAssetId: PropTypes.string.isRequired,
  statusId: PropTypes.string.isRequired,
  status: StatusShape
});
